import { useOpenWithFaireApplicationStatus } from "@faire/deprecated-retailer-visitor-shared/stores/domain/OpenWithFaire/useOpenWithFaireApplicationStatus";
import { QueryParameters as SignUpParams } from "@faire/web-api--source/routes/www/welcome/r";
import success from "@faire/web-api--source/routes/www/welcome/r/success";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export const useEffectOwFApplicationEligibilityRedirect = () => {
  const queryParams = useQueryParams(SignUpParams.parse);
  const history = useHistory();
  const { canApply, hasApplied } = useOpenWithFaireApplicationStatus();

  useEffect(() => {
    if (!canApply) {
      history.push(success(queryParams));
    }
  }, [history, hasApplied, canApply, queryParams]);
  return;
};
